import React, { useContext, useState } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

const RatingSection = ({ id, position = 'bottom-left' }) => {
  const { language } = useContext(LanguageContext);
  const theme = useTheme();
  const [closed, setClosed] = useState(false);

  // Sadece MP425 ve MP405 için göster
  if (id !== 'MP425' && id !== 'MP405') {
    return null;
  }

  if (closed) {
    return null;
  }

  const reviewUrls = {
    MP425: 'https://search.google.com/local/writereview?placeid=ChIJG4hiaSCPKBURaKLsqwp2gbA',
    MP405: 'https://search.google.com/local/writereview?placeid=ChIJ64CAMxOPKBURlWNnxMg0T-U',
  };

  const handleRatingClick = () => {
    const url = reviewUrls[id];
    if (url) {
      window.open(url, '_blank');
    }
  };

  const positionStyle =
    position === 'top-left'
      ? { left: '16px', top: '16px' }
      : { left: '16px', bottom: '16px' };

  return (
    <div
      style={{
        position: 'fixed',
        ...positionStyle,
        zIndex: 9999,
      }}
      aria-label={language === 'Türkçe' ? 'Haritada Puanla' : 'Rate on Maps'}
    >
      <div
        onClick={handleRatingClick}
        style={{
          position: 'relative',
          background: theme.colors.primary,
          borderRadius: '12px',
          padding: '10px 12px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          cursor: 'pointer',
        }}
      >
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setClosed(true);
          }}
          aria-label="Kapat"
          style={{
            position: 'absolute',
            top: '0px',
            right: '-24px',
            width: '22px',
            height: '22px',
            borderRadius: '9999px',
            border: 'none',
            background: 'rgb(17, 24, 39, 0.3)',
            color: '#ffffff',
            fontSize: '14px',
            lineHeight: '22px',
            cursor: 'pointer',
          }}
        >
          ×
        </button>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px' }}>
          {[1, 2, 3, 4, 5].map((star) => (
            <svg
              key={star}
              width="22"
              height="22"
              viewBox="0 0 51 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ transition: 'transform 0.2s' }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              <path
                d="M25.5 0L31.3491 17.7639H49.9634L34.8071 28.7361L40.6562 46.5L25.5 35.5279L10.3438 46.5L16.1929 28.7361L1.03658 17.7639H19.6509L25.5 0Z"
                fill="#FFD700"
              />
              <path
                d="M25.5 0L31.3491 17.7639H49.9634L34.8071 28.7361L40.6562 46.5L25.5 35.5279L10.3438 46.5L16.1929 28.7361L1.03658 17.7639H19.6509L25.5 0Z"
                stroke="#FFA500"
                strokeWidth="2"
              />
            </svg>
          ))}
        </div>

        <div
          style={{
            marginTop: '6px',
            textAlign: 'center',
            fontSize: '12px',
            fontWeight: 600,
            color: '#ffffff',
          }}
        >
          {language === 'Türkçe' ? 'Haritada Puanla' : 'Rate on Maps'}
        </div>
      </div>
    </div>
  );
};

export default RatingSection;
